module.exports = __webpack_public_path__ + "7d9679afa48b80edb9733822fd7727b0.pdf";